import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { logger } from '@origin-digital/reporting-client';

import { useOnce } from 'src/hooks';
import { appendInvalidRedirectUrl } from 'src/utils/helpers';
import { useAppContext } from 'src/context/AppContext';
import { Loading } from 'src/components/Loading';

import { SelectPaymentMethodCard } from './SelectPaymentMethodCard';

export const SelectPaymentMethodScreen: React.SFC = () => {
  const { context } = useAppContext();
  const [mounting, setMounting] = useState<boolean>(true);
  const [invalid, setInvalid] = useState<boolean>(false);

  useOnce(() => {
    setMounting(false);

    if (!context.contractAccountId) {
      logger.info('selectPaymentMethodScreen.setInvalid(): contractAccountId');
      setInvalid(true);
    }
  });

  if (mounting) {
    return <Loading />;
  }

  if (invalid) {
    return (
      <div data-id="redirect-invalid">
        <Redirect to={appendInvalidRedirectUrl('/')} />
      </div>
    );
  }

  return <SelectPaymentMethodCard />;
};
